import React from 'react';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import {
  adminCombineSx,
  adminStatusPillSx,
  adminStatusPillToneSx,
  type AdminStatusPillTone,
} from '../../styles/adminComponentStyles';

type AdminStatusPillProps = {
  label: string;
  startIcon?: React.ReactNode;
  tone?: AdminStatusPillTone;
  sx?: SxProps<Theme>;
};

const AdminStatusPill: React.FC<AdminStatusPillProps> = ({ label, startIcon, tone = 'neutral', sx }) => (
  <Box component="span" sx={adminCombineSx(adminStatusPillSx, adminStatusPillToneSx[tone], sx)}>
    {startIcon && (
      <Box component="span" aria-hidden="true" sx={{ alignItems: 'center', display: 'inline-flex', flexShrink: 0, lineHeight: 0 }}>
        {startIcon}
      </Box>
    )}
    {label}
  </Box>
);

export type { AdminStatusPillTone };
export default React.memo(AdminStatusPill);
